module.exports = __webpack_public_path__ + "img/full5-min.bc16c5a1.png";